export const version = 'kunde-v1.20.0-SNAPSHOT-b481f9a34b3a350dc36a3daadcccacb6ebd02373';